import { render, staticRenderFns } from "./AttestationDepartment.vue?vue&type=template&id=068fab09&"
import script from "./AttestationDepartment.vue?vue&type=script&lang=js&"
export * from "./AttestationDepartment.vue?vue&type=script&lang=js&"
import style0 from "./AttestationDepartment.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports